export function setFacebookURL() {
	var facebookWidth = 500;
	if(window.innerWidth < 500) {
		facebookWidth = (window.innerWidth - 30);
	}
	return `https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fwaihekeadventurecentre%2F&tabs=timeline&width=${facebookWidth}&height=700&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=108359565792`;
}